// extracted by mini-css-extract-plugin
export default {"comments":"PhotoComments_comments__7tTWK","single":"PhotoComments_single__Wolpp"};